const getNavBarHeight = function(){
    return document.querySelector('.js-navigation').getBoundingClientRect().height;
}

const animateScroll = function (element, duration) {
    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
    const elementOffset = element.offsetTop;
    let elementOffsetToScroll = () => {
        let documentHeight = document.body.scrollHeight;
        let offset = Math.round(documentHeight - elementOffset < windowHeight ? documentHeight - windowHeight : elementOffset);
        if(window.innerWidth >= 568) {
            return offset - getNavBarHeight(); //take into account the navigation bar
        }
        else return offset;
    };

    if(!('requestAnimationFrame' in window)){
        window.scroll(0, elementOffsetToScroll());
        return;
    }

    (function scroll(){
        const now = 'now' in window.performance ? performance.now() : new Date().getTime();
        const time = Math.min(1, ((now - startTime) / (duration || 500)));
        const timeFunction = time * (2 - time);
        window.scroll(0, Math.ceil((timeFunction * (elementOffsetToScroll() - start)) + start));

        const totalHeight = document.body.scrollHeight;
        const offsetScroll = elementOffsetToScroll();
        const yOffset = Math.ceil(window.pageYOffset);
        const innerHeight = window.innerHeight;
        if(yOffset >= offsetScroll || (yOffset + innerHeight) === totalHeight){
            return;
        }

        requestAnimationFrame(scroll);
    })();
}

export const Anchored = {
    scrollClick: function(event){
        event.preventDefault();
        this.scrollToElement(event.currentTarget.getAttribute('data-id'));
    },

    scrollToElement: function(id, duration){
        const elem = document.getElementById(id);
        if(elem){
            animateScroll(elem, duration);
        }
    }
};